module.exports = __webpack_public_path__ + "img/riya_null.22c0e2fe.png";